import isNull from 'lodash/isNull';
import {ActionType} from 'redux-promise-middleware';
import {getWindow} from 'ssr-window';
import {CHECKOUT_FETCH_RATES} from 'checkout/checkout-actions';
import CheckoutUtils from 'checkout/checkout-utils';
import {replace} from 'router/router-actions';
import SearchUtils from 'search/search-utils';
import {
    SEARCH_REQUEST_SET_TERM,
    SEARCH_REQUEST_UPDATE_TIMES,
} from 'search-request/search-request-actions';
import {SPOT_CHANGE_MULTI_RATE} from 'spot/spot-actions';
import {matchPathToRoute} from '../../router/routes';
import Arg from '@spothero/arg';

const window = getWindow();

export const searchRequestMiddleware = ({
    dispatch,
    getState,
}) => next => action => {
    switch (action.type) {
        case `${CHECKOUT_FETCH_RATES}_${ActionType.Fulfilled}`: {
            const {
                searchRequest,
                checkout: {rid},
            } = getState();
            const searchParams = {
                rid,
                ...searchRequest,
                ...action.meta,
            };
            const newUrl = CheckoutUtils.updateRoute({
                currentUrl: action.meta.newUrl
                    ? action.meta.newUrl // RecommendedSpotsModal passes a new URL when a different spot is clicked so replace the url with this one
                    : window.location.pathname,
                searchParams,
            });

            dispatch(replace(newUrl));

            break;
        }

        case SPOT_CHANGE_MULTI_RATE: {
            const searchParams = {
                ...getState().searchRequest,
                rid: action.payload.rid,
            };
            const newUrl = CheckoutUtils.updateRoute({
                currentUrl: window.location.pathname,
                searchParams,
            });

            dispatch(replace(newUrl));

            break;
        }

        case SEARCH_REQUEST_SET_TERM:
        case SEARCH_REQUEST_UPDATE_TIMES: {
            const {
                searchRequest,
                destination: {
                    data: {airport, monthly_enabled: monthlyEnabled = null},
                },
            } = getState();
            const {pathname, search} = window.location;
            const route = matchPathToRoute(pathname);

            // Only update route for 'old' URL routes (i.e. catch-all)
            if (isNull(route) || route.path === '/:page/:section?') {
                const newUrl = SearchUtils.updateRoute({
                    currentUrl: window.location.pathname,
                    searchParams: {
                        ...searchRequest,
                        ...action.payload,
                        monthlyEnabled,
                        airport: Boolean(airport),
                    },
                });

                dispatch(replace(newUrl));
            } else if (route.path === '/search') {
                const {
                    type,
                    payload: {monthly: isMonthly},
                } = action;
                const query = Arg.parse(search);

                // if changed to/from monthly search, update URL query accordingly
                if (
                    type === SEARCH_REQUEST_SET_TERM &&
                    query.monthly !== isMonthly
                ) {
                    if (query.monthly) {
                        delete query.monthly;
                    } else {
                        query.monthly = true;
                    }

                    // if spot-id is present in query params, remove it when switching terms and just run a new search
                    delete query['spot-id'];

                    dispatch(replace(`${pathname}?${Arg.stringify(query)}`));
                }
            }

            break;
        }
    }

    return next(action);
};
